interface JoinQuery {
  <T extends Record<string, any>>(records: T): Record<string, string>
}

interface GetFiltersDataFromQuery {
  <T extends Record<string, any>>(template: T, query: Record<string, any>): T;
}

export const delimiter = "|";

const joinQueryValues: JoinQuery = records => {
  const recordsList = Object.entries(records);
  const resultList = recordsList
    .map(([key, value]) => {
      if (typeof value === "object" && value.constructor.name === "Array") {
        return [key, value.join(delimiter)];
      }

      return [key, value];
    })
    .filter(([_, values]) => Boolean(values));
  return Object.fromEntries(resultList);
};


const getFiltersDataFromQuery: GetFiltersDataFromQuery = (template, query) => {
  const result = Object.entries(template).map(([key, value]) => {
    const queryValue = query[key];
    if (!queryValue) {
      return [key, value];
    }

    if (typeof template[key] === "object" && template[key].constructor.name === "Array") {
      return [key, queryValue.split(delimiter)];
    }

    return [key, queryValue];
  })
  return Object.fromEntries(result);
}

export {
  getFiltersDataFromQuery,
  joinQueryValues,
};